'use client';

import { cn } from '@/lib/cn';
import {
  DropdownMenuSubTrigger,
  dropdownMenuItemVariants,
  type DropdownMenuSubTriggerProps,
} from '@heidi/design-system/dropdown-menu';
import { ChevronRight } from 'lucide-react';
import * as React from 'react';

import { NavContext, SubContext, VariantContext, useIsActivePanel } from './context';

export const AdaptiveMenuSubTrigger = ({
  children,
  className,
  disabled,
  'data-testid': testId,
  ...props
}: DropdownMenuSubTriggerProps) => {
  const variant = React.useContext(VariantContext);
  const nav = React.useContext(NavContext);
  const sub = React.useContext(SubContext);
  const isActivePanel = useIsActivePanel();

  if (variant === 'menu') {
    return (
      <DropdownMenuSubTrigger
        className={className}
        disabled={disabled}
        data-testid={testId}
        {...props}
      >
        {children}
      </DropdownMenuSubTrigger>
    );
  }

  // The trigger lives in its parent panel; only show it while that panel is active.
  if (!sub || !nav || !isActivePanel) return null;
  return (
    <button
      type="button"
      disabled={disabled}
      data-disabled={disabled ? '' : undefined}
      data-testid={testId}
      onClick={() => nav.push(sub.subId, sub.onOpenChange)}
      className={cn(
        dropdownMenuItemVariants({}),
        'min-h-11 w-full',
        disabled && 'cursor-default',
        className
      )}
    >
      {children}
      <ChevronRight className="ms-auto size-4 rtl:-scale-x-100" />
    </button>
  );
};
